import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import "../scss/Common.scss";
import "../scss/ListView.scss";
import { getWorks } from "../api";
import { useQuery } from "@tanstack/react-query";
import WideTile from "../components/Views/WideTile";
import WideTileListView from "../components/Views/WideTileListView";
export default function Works() {
  const nav = useNavigate();

  const workQuery = useQuery({
    queryKey: ["works"],
    queryFn: getWorks,
  });

  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
      }}
    >
      <Header />
      <WideTileListView data={workQuery.data} keyWord="works" />
    </div>
  );
}
